<template>
  <div :id="'PDFDownloadContainer-' + releaseID" class="PDFDownloadContainer">
    <div :id="'PDFDownload-' + releaseID" class="PDFDownload">
      <div id="PDFDownloadContent">
        <div class="pdf-title">{{ this.companyTitle }}</div>
        <!--台達電子股份有限公司 出廠放行單-->
        <div class="pdf-box">
          <el-row :gutter="24">
            <el-col :span="12">
              {{ $t("pages.wording.releaseNo") }}: {{ releaseData.releaseOrderNo
              }}<!--放行單號-->
            </el-col>
            <el-col :span="12">
              {{ $t("pages.wording.printDate") }}: {{ pdfPringDate
              }}<!--打印日期-->
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              {{ $t("pages.wording.applicatorID") }}:{{ applicatorData.userID
              }}<!--填單人工號-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.applicatorName") }}:{{ applicatorData.userName
              }}<!--填單人-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.applicatorNumber") }}:{{ applicatorData.userPhone
              }}<!--填單人分機-->
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              {{ $t("pages.wording.applicatorDepCode") }}:{{ applicatorData.deptCode
              }}<!--部門代碼-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.applicatorDepName") }}: {{ applicatorData.userDept
              }}<!--部門名稱-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.applicatorArea") }}:{{ reserveData.reserveArea
              }}<!--填單人廠區-->
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              {{ $t("pages.wording.carPlat") }}:{{ reserveData.tempCar ? reserveData.tmpCarPlat : reserveData.carPlat
              }}<!--車牌號碼-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.vendorCustom") }}:{{ reserveData.vendor
              }}<!--廠商/客戶-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.salesDate") }}:{{ releaseData.saleDate
              }}<!--出售日期-->
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              {{ $t("pages.wording.reserveFactory") }}:{{ reserveData.reserveFactory
              }}<!--抵達廠別-->
            </el-col>
            <el-col :span="8">
              {{ $t("pages.wording.reserveLocation") }}:{{
                $store.getters.getSysCodeText("location", reserveData.reserveLocation)
              }}<!--抵達地點-->
            </el-col> </el-row
          ><!--pdf-box-->
        </div>
        <div class="pdf-box">
          <el-row :gutter="24">
            <el-col :span="24">
              {{ $t("pages.wording.releaseOrderDetail")
              }}<!--放行單明細資料-->
            </el-col>
          </el-row>
          <el-table class="pdf-soTable" :data="soList" border style="width: 100%">
            <el-table-column prop="SO" label="SO" width="80"></el-table-column
            ><!--SO--><!--so-->
            <el-table-column prop="SOLine" label="SO LINE" width="80"></el-table-column
            ><!--SO LINE--><!--soLine-->
            <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="100"></el-table-column
            ><!--廢料料號--><!--partNo-->
            <el-table-column :label="$t('pages.wording.partName')" width="100">
              <template slot-scope="scope">
                {{ displayPartName(getLanguage(), scope.row.partNameCN, scope.row.partName) }}
              </template> </el-table-column
            ><!--廢料名稱--><!--partName-->
            <el-table-column prop="grossWeight" :label="$t('pages.wording.grossWeight')" width="80"></el-table-column
            ><!--毛重--><!--grossWeight-->
            <el-table-column prop="packType" :label="$t('pages.wording.packType')" width="80">
              <template slot-scope="scope">
                {{ $store.getters.getSysCodeText("packType", scope.row.packType) }}
              </template> </el-table-column
            ><!--包裝種類--><!--packType-->
            <el-table-column prop="packNumber" :label="$t('pages.wording.packNumber')" width="80"></el-table-column
            ><!--包裝數量--><!--packNumber-->
            <el-table-column prop="packWeight" :label="$t('pages.wording.packWeight')" width="80"></el-table-column
            ><!--總皮重--><!--packWeight-->
            <el-table-column prop="netWeight" :label="$t('pages.wording.netWeight')" width="80"></el-table-column
            ><!--淨重--><!--netWeight-->
            <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="80"></el-table-column
            ><!--單位--><!--unit-->
            <el-table-column prop="plantCode" label="Plant Code" width="100"></el-table-column
            ><!--PlantCode--><!--plantCode-->
            <el-table-column prop="storageLogic" label="Storage Loc."></el-table-column
            ><!--PlantCode--><!--storageLogic-->
          </el-table>
        </div>
        <!--pdf-box-->
        <div class="pdf-box">
          <el-row :gutter="24">
            <el-col :span="24">
              {{ $t("pages.wording.signProcess")
              }}<!--簽核流程-->
            </el-col>
          </el-row>
          <el-row v-for="n in 3" :key="n" :gutter="24">
            <el-col :span="12">
              {{ pdfSignArray[n * 2 - 2] }}
            </el-col>
            <el-col :span="12">
              {{ pdfSignArray[n * 2 - 1] }}
            </el-col>
          </el-row>
        </div>
      </div>
      <!--pdf-box-->
    </div>
    <!--PDFDownload-->
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { jsPDF } from "jspdf"
import * as html2canvas from "html2canvas"
import { mapGetters } from "vuex"

export default {
  name: "PDFDownload",
  props: ["releaseID"],
  data() {
    return {
      companyTitle: "",
      pdfPringDate: "",
      pdfSignArray: [],
      releaseData: {},
      reserveData: {},
      applicatorData: {},
      soList: [],
      signTable: [],
      soRuleForm: {
        soList: [],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapGetters(["getLanguage"]),
    init() {
      this.getReleaseInfo(this.$props.releaseID)
      //this.getSignTable(this.$props.releaseID);
      this.builPdf()
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    pdfDlownload() {
      var vm = this
      var id = "#PDFDownload-" + this.$props.releaseID + " #PDFDownloadContent"
      var body = document.querySelector(id)
      html2canvas(body).then((canvas) => {
        var pdf = new jsPDF("p", "pt", "a4")

        var standarWidth = pdf.internal.pageSize.getWidth() - 10 //595.28
        var standarHeight = pdf.internal.pageSize.getHeight() - 35 //780
        var originWidth = body.scrollWidth //原始圖像寬
        var originHeight = (originWidth / standarWidth) * standarHeight //按a4比例原始圖像高

        for (var i = 0; i <= body.scrollHeight / originHeight; i++) {
          //! This is all just html2canvas stuff
          var srcImg = canvas
          var sX = 0
          var sY = originHeight * i // start 980 pixels down for every new page
          var sWidth = originWidth
          var sHeight = originHeight
          var dX = 10
          var dY = 10
          var dWidth = standarWidth
          var dHeight = standarHeight
          var pdfWidth = pdf.internal.pageSize.getWidth()
          var pdfHeight = pdf.internal.pageSize.getHeight()

          window.onePageCanvas = document.createElement("canvas")
          window.onePageCanvas.setAttribute("width", sWidth)
          window.onePageCanvas.setAttribute("height", sHeight)
          var ctx = window.onePageCanvas.getContext("2d")
          ctx.fillStyle = "#FFFFFF"
          ctx.fillRect(0, 0, sWidth, sHeight)
          // details on this usage of this function:
          // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
          //ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, sWidth-20, sHeight-20);
          ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, sWidth, sHeight)
          // document.body.appendChild(canvas);
          var canvasDataURL = window.onePageCanvas.toDataURL("image/jpeg", 3.0)
          if (i > 0) {
            pdf.addPage() //8.5" x 11" in pts (in*72)
          }
          // pdf.addImage(canvasDataURL, 'JPEG', 5, 20, dWidth, dHeight);
          pdf.addImage(canvasDataURL, "JPEG", 5, 20, dWidth, dHeight)
        }
        pdf.save(`${this.$t("pages.wording.releaseOrder")}-${vm.releaseData.releaseOrderNo}.pdf`)
      })
    },
    pdfWindowPrint() {
      var vm = this
      var id = "#PDFDownload-" + this.$props.releaseID + " #PDFDownloadContent"
      var body = document.querySelector(id)
      html2canvas(body).then((canvas) => {
        var pdf = new jsPDF("p", "pt", "a4")

        var standarWidth = 595.28
        var standarHeight = 780
        var originWidth = body.scrollWidth //原始圖像寬
        var originHeight = (originWidth / standarWidth) * standarHeight //按a4比例原始圖像高

        for (var i = 0; i <= body.scrollHeight / originHeight; i++) {
          //! This is all just html2canvas stuff
          var srcImg = canvas
          var sX = 0
          var sY = originHeight * i // start 980 pixels down for every new page
          var sWidth = originWidth
          var sHeight = originHeight
          var dX = 10
          var dY = 10
          var dWidth = standarWidth
          var dHeight = standarHeight

          window.onePageCanvas = document.createElement("canvas")
          window.onePageCanvas.setAttribute("width", sWidth)
          window.onePageCanvas.setAttribute("height", sHeight)
          var ctx = window.onePageCanvas.getContext("2d")
          ctx.fillStyle = "#FFFFFF"
          ctx.fillRect(0, 0, sWidth, sHeight)
          // details on this usage of this function:
          // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
          ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, sWidth - 20, sHeight - 20)
          // document.body.appendChild(canvas);
          var canvasDataURL = window.onePageCanvas.toDataURL("image/jpeg", 3.0)
          if (i > 0) {
            pdf.addPage() //8.5" x 11" in pts (in*72)
          }
          pdf.addImage(canvasDataURL, "JPEG", 5, 20, dWidth, dHeight)
        }
        window.open(
          pdf.output("bloburl", {
            filename: `${this.$t("pages.wording.releaseOrder")}-${vm.releaseData.releaseOrderNo}.pdf`,
          }),
          "_blank"
        )
      })
    },
    getReleaseInfo(id) {
      var paramter = { releaseId: id }
      var vm = this
      api.apiGetReleaseInfo({ params: paramter }).then((response) => {
        if (response.status === 200) {
          var datas = response.data.result
          vm.releaseData = datas.releseData
          vm.reserveData = datas.reserveData
          vm.soList = datas.soList
          if (vm.soList.length > 0) {
            api.apiGetCompanyNameByPlantCode({ params: { plantCode: vm.soList[0].plantCode } }).then((response) => {
              if (response.status === 200) {
                let result = response.data
                this.companyTitle = result
              }
            })
          }
          vm.getUserAuthInfo(vm.reserveData.applicatorNT)
          vm.getSignTable(vm.$props.releaseID)
        }
      })
      //this.$store.dispatch('getReleaseInfo',{params:paramter})
    },
    getSignTable(id) {
      var paramter = { releaseId: id }
      var vm = this

      api.apiGetSignTable(paramter).then((response) => {
        var datas = response.data
        vm.signTable = datas.result
        vm.buildPdfSignArray(datas.result)
      })
      //this.$store.dispatch('getSignTable',{params:paramter})
    },
    getUserAuthInfo(nt) {
      var vm = this
      var paramter = { ntaccount: nt }
      api.apiGetUserAuthInfo({ params: paramter }).then((response) => {
        var datas = response.data
        vm.applicatorData = datas
      })
      //this.$store.dispatch('getUserAuthInfo',{params:{'ntaccount': nt}});
    },
    builPdf() {
      var date = utils.getDateTime(new Date())
      this.pdfPringDate = date[0]
    },
    buildPdfSignArray(signList) {
      var vm = this
      this.pdfSignArray = []

      var applyDateTime = utils.getDateTime(new Date(utils.newDateFormat(this.reserveData.applyDatetime)))
      var applyString = `[${vm.$t("pages.wording.apply")}][${applyDateTime[0]} ${applyDateTime[1]} ${
        this.reserveData.applicatorName
      }]${vm.$t("pages.wording.send")}`
      this.pdfSignArray.push(applyString)
      signList.forEach(function (item, index) {
        let signDateTime = item.signDate + " " + item.signTime
        let signString = `[${vm.$t("role." + item.signRole)}][${signDateTime} ${item.signUserName}]${vm.$t(
          "pages.wording.approved"
        )}`

        if (index == signList.length - 1) signString += "---" + vm.$t("pages.wording.reviewed")

        vm.pdfSignArray.push(signString)
      })

      var leaveTime = this.reserveData.leaveDatetime
        ? utils.getFormateDateTime("DateTime", this.reserveData.leaveDatetime)
        : ""
      this.pdfSignArray.push(`${vm.$t("pages.wording.departuretime")}:${leaveTime}`)
    },
  },
  watch: {
    /*"$store.getters.releaseInfo" : function(val){ //資料by Rlease No 抓取並回傳且build到頁面上

					//save as origion data
					this.releaseData = val.releseData;
					this.reserveData = val.reserveData;
					this.soList = val.soList;
					this.getUserAuthInfo(this.reserveData.applicatorNT);
				},
				"$store.getters.signTable" : function(signList){
					
					this.buildPdfSignArray(signList);//產生pdf要下載簽核內容
				},
				"$store.getters.userInfo" : function(data){
					this.applicatorData = data
					/*this.applicator.name = data.userName;
					this.applicator.number = data.userPhone;
					this.applicator.deptName = data.userDept;
					this.applicator.area = data.area;
					this.applicator.deptCode = data.deptCode;*
				
				}*/
  },
}
</script>

<style>
.PDFDownloadContainer {
  height: 1px;
  position: absolute;
  overflow: hidden;
  top: 0px;
}
.PDFDownload {
  position: absolute;
  width: 1240px;
  height: 1754px;
  font-size: 18px;
}
.PDFDownloadContent {
  padding: 50px;
}
.pdf-title {
  width: 100%;
  text-align: center;
  margin: 10px auto;
  border-bottom: 1px #000 solid;
}
.PDFDownload .el-row {
  margin: 10px 0px;
}
.PDFDownload .pdf-box {
  padding-bottom: 30px;
  border-bottom: 1px #000 solid;
}
</style>
